import React from "react";
import { Link } from "react-router-dom";
import { FaBus, FaShuttleVan, FaBusAlt } from "react-icons/fa";

const buses = [
  {
    icon: <FaBus size={28} />,
    label: "Airy Buses",
    color: "#3b82f6",
    border: "rgba(59,130,246,0.2)",
  },
  {
    icon: <FaBusAlt size={28} />,
    label: "10+ Large Buses",
    color: "#ec4899",
    border: "rgba(236,72,153,0.2)",
  },
  {
    icon: <FaShuttleVan size={28} />,
    label: "Mini Buses",
    color: "#f4c842",
    border: "rgba(244,200,66,0.2)",
  },
];

const transportImages = [
  {
    img: "/renamed_website_images/school-transport-bus-1.jpg",
    alt: "School bus parked near school",
  },
  {
    img: "/renamed_website_images/school-transport-bus-2.jpg",
    alt: "School bus on street",
  },
  {
    img: "/renamed_website_images/school-transport-bus-1.jpg",
    alt: "School bus on road",
  },
  {
    img: "/renamed_website_images/school-transport-bus-2.jpg",
    alt: "Mini school bus",
  },
];

const Transport = () => {
  return (
    <section className="relative min-h-screen pt-36 md:pt-40 pb-20 px-6 md:px-16 md:pt-[96px] overflow-hidden">
      <div
        className="absolute bottom-0 right-0 w-96 h-96 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(59,130,246,0.07) 0%, transparent 70%)",
        }}
      />

      <div className="max-w-6xl mx-auto relative z-10">
        <Link
          to="/facilities"
          className="inline-block text-sm font-bold tracking-wide mb-8 transition-colors duration-200"
          style={{ fontFamily: "Nunito, sans-serif", color: "#f4c842" }}
        >
          ← Back to Facilities
        </Link>

        <h1
          className="uppercase mb-4"
          style={{
            fontFamily: "Orbitron, sans-serif",
            fontWeight: 900,
            fontSize: "clamp(1.8rem, 4vw, 3rem)",
            color: "#f0f5ff",
          }}
        >
          School Transport
        </h1>
        <div className="cosmic-divider mb-10" />

        {/* Feature cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {buses.map((b, i) => (
            <div
              key={i}
              className="glass-card p-7 flex flex-col items-center gap-4 transition-all duration-300 hover:scale-[1.02]"
              style={{ borderColor: b.border }}
            >
              <div
                className="w-14 h-14 rounded-full flex items-center justify-center"
                style={{
                  background: `${b.color}18`,
                  border: `1px solid ${b.border}`,
                  color: b.color,
                }}
              >
                {b.icon}
              </div>
              <h4
                className="font-bold"
                style={{
                  fontFamily: "Cinzel, serif",
                  color: "#f0f5ff",
                  fontSize: "1rem",
                }}
              >
                {b.label}
              </h4>
            </div>
          ))}
        </div>

        <p
          className="text-center max-w-2xl mx-auto mb-12"
          style={{
            fontFamily: "Nunito, sans-serif",
            color: "#8899b8",
            fontSize: "0.95rem",
            lineHeight: "1.8",
          }}
        >
          Our school transport system is designed for safety, comfort, and
          punctuality. All vehicles are maintained to the highest standards to
          ensure students travel with ease and confidence, whether on long
          routes or through tighter streets.
        </p>

        {/* Images */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {transportImages.map((img, i) => (
            <div
              key={i}
              className="rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
              style={{
                border: "1px solid rgba(59,130,246,0.2)",
                boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
              }}
            >
              <img
                src={img.img}
                alt={img.alt}
                className="w-full object-cover"
                style={{ height: "180px" }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Transport;
